import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import ShopItemForm from '@/modules/shop/components/ShopItemForm'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'

function CreateShopItemPage() {
	const navigate = useNavigate()

	const handleSuccess = () => {
		navigate(-1)
	}

	const handleBack = () => {
		navigate(-1)
	}

	return (
		<PageContainer>
			<div className="mx-auto max-w-2xl">
				<div className="mb-6 flex items-center gap-4">
					<Button variant="outline" size="sm" onClick={handleBack}>
						<ArrowLeft className="mr-2 h-4 w-4" />
						กลับ
					</Button>
					<h1 className="text-2xl font-semibold">สร้างสินค้าใหม่</h1>
				</div>
				<ShopItemForm mode="create" onSuccess={handleSuccess} />
			</div>
		</PageContainer>
	)
}

export default withUserPermission(CreateShopItemPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_SHOP],
})
